<template>
  <v-layout class="inner-pages" column >
    <Header />

    <scroll-data :footer="false">

      <v-layout column class="align-self-start">
        <v-layout>
        <v-flex xs8>
          <v-select
            v-model="selectedProgram"
            :items="programs"
            item-text="name"
            item-value="id"
            label="Program"
            :disabled="users.length === 0"
          ></v-select>

        </v-flex>
        <v-flex xs4 text-xs-right>
          <v-btn
            @click="fetchReport"
            :disabled="users.length === 0"
            outline color="primary" >
            <span class="notranslate"><v-icon v-if="!isXs">bar_chart</v-icon></span> Report
          </v-btn>
        </v-flex>
        </v-layout>
<!--        <v-flex xs12>-->
<!--          <v-layout class="justify-center">-->

<!--              <v-btn-->
<!--                class="pa-1  ma-1"-->
<!--              :disabled="users.length === 0"-->
<!--                :href="`mailto:${teamEmails}`"-->
<!--              outline color="primary" >-->
<!--              <span class="notranslate"><v-icon v-if="!isXs">mail_outline</v-icon></span>&nbsp;Email Team-->
<!--            </v-btn>-->

<!--              <v-btn-->
<!--                class="pa-1 ma-1"-->
<!--              :disabled="users.length === 0"-->
<!--              outline color="primary" @click="recordEvent">-->
<!--                <span class="notranslate"><v-icon v-if="!isXs">date_range</v-icon></span>&nbsp;Record Event-->
<!--            </v-btn>-->



<!--              <v-btn-->
<!--                class="pa-1 ma-1"-->
<!--                @click="fetchReport"-->
<!--                :disabled="users.length === 0"-->
<!--                outline color="primary" >-->
<!--                <span class="notranslate"><v-icon v-if="!isXs">bar_chart</v-icon></span> Report-->
<!--              </v-btn>-->

<!--          </v-layout>-->

<!--        </v-flex>-->
        <v-flex xs12 class="mt-2">
            <v-flex xs12>
              <v-layout class="font-weight-bold align-end">
                <v-flex xs4>
                  <v-layout>
                    <v-flex xs12>Team Member</v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs3>Status</v-flex>
                <v-flex xs2>Hours</v-flex>
                <v-flex xs3>License Date</v-flex>
              </v-layout>
              <v-divider />
            </v-flex>
            <v-flex xs12 v-for="user in users" :key="'row_'+user.userId">

              <v-layout class="py-1">
                <v-flex xs4>
                  <v-layout>
                    <v-flex class="d-inline-flex primary--text" xs12>
                      <span
                        :style="{
                    backgroundImage: 'url(https://api.cogneti.com/ws/playerservice/user/'+ user.userId +'/blob)',
                    backgroundSize: 'contain',
                    maxWidth: $vuetify.breakpoint.name === 'xs' ? '20px' : '30px',
                  }"></span>
                      <span style="cursor: pointer;"  @click.stop="getSelectedUSer(user)">
                        {{ user.firstName }} {{ user.lastName }}</span>
                    </v-flex>

                  </v-layout>
                </v-flex>
                <v-flex xs3 style="align-self: center">
                  <strong class="notranslate " :class="statusClass[user.progress.toLowerCase()]">{{ statusString[user.progress.toLowerCase()] }}</strong>
                </v-flex>
                <v-flex xs2 style="align-self: center">{{formatTime(user.dorMins + user.rcaMins + user.metricMins)}}</v-flex>
                <v-flex> {{user.licenseDate ? new Date(user.licenseDate).toLocaleDateString('en-GB', {
                  day : 'numeric',
                  month : 'short',
                  year : 'numeric'
                }).split(' ').join('-') : '-'}}</v-flex>
              </v-layout>
              <v-divider />
            </v-flex>
        </v-flex>
      </v-layout>

    </scroll-data>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">

      <v-card>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8>
        <v-card-title class="pa-0">

          <div style="cursor: pointer;" class="align-center d-inline-flex  primary--text title"
               @click.stop="dialog=false">
            <v-breadcrumbs :items="memberDialogHeader">
              <template v-slot:item="props">
                <a href="javascript:void(0)"
                   v-if="!props.item.disabled"
                   class="subheading"
                   :class="[props.item.disabled && 'disabled']">{{ props.item.text }}</a>
                <span class="subheading text--disabled" v-else>{{ props.item.text }}</span>
              </template>
            </v-breadcrumbs>
          </div>

        </v-card-title>
        <v-divider class="mt-0"></v-divider>
        <v-card-text>
          <v-flex xs12>
            <v-layout class="justify-center">

              <v-btn outline color="primary"
                     :href="`mailto:${selectedMember.email}`"
              >
                <span class="notranslate"><v-icon >mail_outline</v-icon></span>&nbsp;Email
              </v-btn>

              <v-btn outline color="primary"
                     class="hidden-sm-and-up"
                     :href="`sms:${selectedUser.phoneNumber}`"
              >
                <span class="notranslate"><v-icon>chat</v-icon></span>&nbsp;SMS
              </v-btn>

              <v-btn outline color="primary" class="hidden-sm-and-up"
                     :href="`phone:${selectedUser.phoneNumber}`"
              >
                <span class="notranslate"><v-icon>call</v-icon></span>&nbsp;Call
              </v-btn>
            </v-layout>
          </v-flex>
          <v-flex xs12 lg6 offset-lg3>
            <div style="height:30px" class="align-center d-flex font-weight-black justify-center primary white--text">
              {{ selectedMember.firstName }} {{ selectedMember.lastName }}
            </div>
            <table class="table">
              <tr>
                <td style="width:40%">User ID</td>
                <td style="width:60%">{{selectedUser.id}}</td>
              </tr>
              <tr>
                <td>Friendly Name</td>
                <td>
                  {{selectedUser.friendlyName}}
                </td>
              </tr>
              <tr>
                <td>Phone</td>
                <td>{{selectedUser.phoneNumber}}</td>
              </tr>
              <tr>
                <td>Location</td>
                <td>{{selectedUser.city}}
                  <span v-if="selectedUser.countryId === 233"> - United States</span>
                </td>
              </tr>
              <tr>
                <td>email</td>
                <td>{{selectedUser.email}}</td>
              </tr>
              <tr>
                <td>License Date</td>
                <td>
                  {{selectedMember.licenseDate ? new Date(selectedMember.licenseDate).toLocaleDateString('en-GB', {
                  day : 'numeric',
                  month : 'short',
                  year : 'numeric'
                }).split(' ').join('-') : '-'}}

                </td>
              </tr>
              <tr>
                <td>Certificate Progress</td>
                <td>
                  <span class="notranslate"><v-icon :class="programImagesClass[selectedMember.progress.toLowerCase()]"
                                                    v-text="programImages[selectedMember.progress.toLowerCase()]"/></span>
                </td>
              </tr>
              <tr>
                <td>Skill</td>
                <td>
                  <div style="height:20px;width:20px;transform: rotate(-90deg)">
                    <v-progress-linear
                      v-for="skill in selectedMember.skills"
                      :key="Math.random()"
                      height="3"
                      :value="skill"
                      style="margin: 0 0 1px 0"
                      background-color="transparent"
                    ></v-progress-linear>
                  </div>
                </td>
              </tr>

            </table>
          </v-flex>
          <v-flex  xs12 lg6 offset-lg3 class="text-xs-center"
                   v-if="selectedMember.progress.toLowerCase() === 'badged'">
            <img class="elevation-10" v-if="frontImg"
                 style="height:150px;border-radius: 10px;" :src="frontImg">
            <v-img class="pa-5" v-if="frontImg === ''">
              <v-progress-circular indeterminate color="blue lighten-2"></v-progress-circular>
            </v-img>
            <v-form
              ref="badgeEmailForm"
              v-model="badgeEmailFormValid"
              lazy-validation
            >
              <v-flex>

                <v-text-field
                  v-model="badgeEmails"
                  :rules="badgeEmailsRules"
                  label="Send badge to"
                  placeholder="bigz@example.com, manager@example.com"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-btn @click="validateSendBadgeInEmail" :disabled="!badgeEmailFormValid || !badgeId"
                       :loading="loadingSendBadgeMail" block color="primary">Email Badge
                </v-btn>
                <v-btn color="primary" block :disabled="certificateMailSend  || !badgeId"
                       :loading="loadingSendCertificateMail"
                       @click="sendCertificateMail">Email Certificate
                </v-btn>
              </v-flex>
            </v-form>
          </v-flex>
        </v-card-text>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>


    <v-dialog v-model="recordEventDialog" fullscreen hide-overlay transition="dialog-bottom-transition">

      <v-card>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8>
            <v-card-title class="pa-0">

              <div style="cursor: pointer;" class="align-center d-inline-flex"
                   @click.stop="recordEventDialog=false">
                <v-breadcrumbs :items="recordEventDialogHeader">
                  <template v-slot:item="props">
                    <a href="javascript:void(0)"
                       v-if="!props.item.disabled"
                       class="subheading"
                       :class="[props.item.disabled && 'disabled']">{{ props.item.text }}</a>
                    <span class="subheading text--disabled" v-else>{{ props.item.text }}</span>
                  </template>
                </v-breadcrumbs>
              </div>
            </v-card-title>
            <v-divider class="mt-0"></v-divider>
            <v-card-text>
              <v-flex xs12 lg6 offset-lg3>
                <v-form
                  ref="eventForm"
                  v-model="validEventForm"
                  lazy-validation
                >
<!--                  <v-text-field-->
<!--                    v-model="recorder"-->
<!--                    label="Recorder"-->
<!--                    disabled-->
<!--                    outline-->
<!--                  ></v-text-field>-->

                  <v-text-field
                    v-model="eventName"
                    label="Event Name"
                    :rules="[v => !!v || 'Event Name is required']"
                    required
                    outline
                  ></v-text-field>

                  <v-select
                    v-model="eventType"
                    :items="eventTypes"
                    :rules="[v => !!v || 'Please select Event Type']"
                    label="Event Type"
                    required
                    outline
                  ></v-select>

                  <v-textarea
                    v-model="eventDescription"
                    label="Description"
                    :rules="[v => !!v || 'Description is required']"
                    required
                    outline
                  ></v-textarea>

                  <v-text-field
                    v-model="eventLocation"
                    label="Location"
                    :rules="[v => !!v || 'Location is required']"
                    required
                    outline
                  ></v-text-field>

                  <v-menu
                    ref="menu"
                    v-model="dateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="eventDate"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                    outline
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="eventDate"
                        label="Event Date"
                        :rules="[v => !!v || 'Please select Event Date']"
                        readonly
                        outline
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="eventDate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="dateMenu = false">Cancel</v-btn>
                      <v-btn flat color="primary" @click="$refs.menu.save(eventDate)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>

                  <v-menu
                    ref="menu1"
                    v-model="timeMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="eventTime"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="eventTime"
                        label="Event Start Time"
                        :rules="[v => !!v || 'Please select Event Start Time']"
                        readonly
                        outline
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="timeMenu"
                      v-model="eventTime"
                      full-width
                    >
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="timeMenu = false">Cancel</v-btn>
                      <v-btn flat color="primary" @click="$refs.menu1.save(eventTime)">OK</v-btn>
                    </v-time-picker>
                  </v-menu>

                  <v-select
                    v-model="selectedParticipants"
                    :items="participants"
                    :item-text = "(obj) => obj.firstName + ' ' + obj.lastName"
                    item-value="userId"
                    :rules="[v => v.length !== 0 || 'Please select Attendees']"
                    :label="selectedParticipants.length > 0 ? 'Attendees('+selectedParticipants.length+')' : 'Attendees'"
                    multiple
                    outline
                    chips
                  >
                    <template v-slot:prepend-item>
                      <v-list-tile
                        ripple
                        @click="toggleSelectAllParticipants"
                      >
                        <v-list-tile-action>
                          <v-checkbox
                            label="Select All"
                            :indeterminate="selectedParticipants.length < participants.length && selectedParticipants.length > 0"
                            :input-value="selectedParticipants.length === participants.length"
                            value></v-checkbox>
                        </v-list-tile-action>
                      </v-list-tile>
                      <v-divider class="mt-2"></v-divider>
                    </template>

                  </v-select>

                  <v-flex xs12 d-flex>
                    <v-flex xs2 class="font-weight-bold d-flex mt-3">
                      Total Time
                    </v-flex>
                    <v-flex md4 xs5 px-3>
                      <v-select
                        :items="arrayRange(1, 23, 1)"
                        label="Hours"
                        outline
                        v-model="eventHours"
                        :rules="[v => !!v || 'required']"
                        required
                      ></v-select>
                    </v-flex>
                    <v-flex md4 xs5 px-3>
                      <v-select
                        :items="arrayRange(0, 59, 1)"
                        label="Minutes"
                        v-model="eventMinutes"
                        outline
                      ></v-select>
                    </v-flex>
                  </v-flex>

                  <v-flex class="text-xs-center">

                    <v-btn
                      :loading="eventFormLoader"
                      :disabled="!validEventForm"
                      color="success"
                      @click="validateEventForm"
                    >
                      Submit
                    </v-btn>
                    <v-btn
                      @click="recordEventDialog=false"
                    >
                      Cancel
                    </v-btn>
                  </v-flex>

                </v-form>

              </v-flex>
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

  </v-layout>
</template>

<script>
  import ScrollData from '../ScrollData'
  import Header from '../layouts/Header'

  export default {
    name: 'ComplianceCenter',
    components: {Header, ScrollData},
    data: () => ({
      memberDialogHeader: [
        {
          text: 'ComplianceCenter',
          disabled: false,
          href: 'ComplianceCenter'
        },
        {
          text: 'Member',
          disabled: true,
          href: ''
        }
      ],
      statusString: {
        'badged': 'Complete',
        'training': 'In Progress',
        'expired': 'Expired'
      },
      statusClass: {
        'badged': 'success--text',
        'training': '',
        'expired': 'error--text'
      },
      eventFormLoader: false,
      selectedParticipants: [],
      participants: [],
      timeMenu: false,
      dateMenu: false,
      eventHours: '',
      eventMinutes: 0,
      eventTime: null,
      eventDate: new Date().toISOString().substr(0, 10),
      eventLocation: '',
      eventDescription: '',
      eventName: '',
      eventType: '',
      eventTypes: ['Other'],
      validEventForm: true,
      recordEventDialog: false,
      loadingSendBadgeMail: false,
      certificateMailSend: false,
      loadingSendCertificateMail: false,
      badgeMailSend: false,
      badgeId: '',
      badgeEmails: '',
      badgeEmailsRules: [
        v => !!v || 'E-mail is required',
        v => /^$|^((\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+))$/g.test(v) || 'E-mail must be valid'
      ],
      badgeEmailFormValid: false,
      dialog: false,
      selectedProgram: '',
      frontImg: '',
      selectedUser: {},
      selectedMember: {
        progress: 'badged'
      },
      programImages: {
        'badged': 'verified_user',
        'training': 'model_training',
        'expired': 'cancel',
        'licensed': 'account_circle',
        'registered': 'account_circle'
      },
      programImagesClass: {
        'badged': 'green--text',
        'training': 'orange--text',
        'expired': 'error--text',
        'licensed': 'primary--text',
        'registered': 'gray--text'
      },
      users: []
    }),
    computed: {
      teamEmails () {
        return this.users.map(user => user.email)
      },
      isXs () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
      recordEventDialogHeader () {
        return [
          {
            text: 'ComplianceCenter',
            disabled: false,
            href: 'ComplianceCenter'
          },
          {
            text: 'Recording event by ' + this.recorder,
            disabled: true,
            href: ''
          }
        ]
      },
      recorder () {
        return this.$store.getters['user/getFirstName'] + ' ' + this.$store.getters['user/getLastName']
      },
      recorderId () {
        return this.$store.getters['user/getUserId']
      },
      programs () {
        return this.$store.getters['complianceProgram/getPrograms']
      },
      allParticipants () {
        return this.selectedParticipants.length === this.participants.length
      },
      someParticipants () {
        return this.selectedParticipants.length > 0 && !this.allParticipants
      },
      icon () {
        if (this.allParticipants) return 'mdi-close-box'
        if (this.someParticipants) return 'mdi-minus-box'
        return 'checkbox'
      }
    },
    created () {
      setTimeout(() => {
        this.$store.commit('setIsCompactHeader', false)
        this.selectedProgram = this.programs[0].id
        this.$store.commit('setPageSubTitle', this.programs[0].company)
      }, 100)

      this.fetchProgram()
    },
    methods: {
      toJSONLocal (date) {
        const local = new Date(date)
        local.setMinutes(date.getMinutes() - date.getTimezoneOffset())
        return local.toJSON().slice(0, 10)
      },
      fetchReport () {
        this.$store.dispatch('complianceProgram/fetchReport', {courseId: 59, programId: 1}).then(response => {
          let currentDate = new Date().toJSON().slice(0, 10)
          const anchor = document.createElement('a')
          anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(response.data)
          anchor.target = '_blank'
          anchor.download = this.programs[0].name.split(' ').join('-') + '-report-' + currentDate + '.csv'
          anchor.click()
          this.$store.commit('flashSuccess', 'Report downloaded successfully.')
        })
      },
      fetchProgram () {
        this.$store.dispatch('complianceProgram/fetchProgram', {courseId: 59, programId: 1}).then(response => {
          this.users = response.data
        })
      },
      arrayRange (start, stop, step) {
        return Array.from(
          { length: (stop - start) / step + 1 },
          (value, index) => start + index * step
        )
      },
      toggleSelectAllParticipants () {
        this.$nextTick(() => {
          if (this.allParticipants) {
            this.selectedParticipants = []
          } else {
            this.selectedParticipants = this.participants.map(participant => participant.userId)
          }
        })
      },
      validateEventForm () {
        if (this.$refs.eventForm.validate()) {
          const data = {
            'progId': this.selectedProgram,
            'name': this.eventName,
            'eventType': this.eventType.trim(),
            'location': this.eventLocation,
            'description': this.eventDescription,
            'eventDate': this.eventDate + 'T' + this.eventTime + ':0',
            'createdBy': this.recorderId,
            'totalMinutes': (this.eventHours * 60) + this.eventMinutes,
            'participants': this.participants.map(participant => {
              return {
                userId: participant.userId,
                attendance: this.selectedParticipants.includes(participant.userId)
              }
            })
          }
          this.eventFormLoader = true
          this.$store.dispatch('complianceProgram/createEvent', {data, programId: this.selectedProgram}).then(response => {
            this.recordEventDialog = false
            this.eventFormLoader = false
            this.$store.commit('flashSuccess', 'Event created successfully.')
            this.fetchProgram()
          })
        }
      },
      recordEvent () {
        this.recordEventDialog = true
        this.$store.dispatch('complianceProgram/newEventDetails', 1).then(response => {
          this.eventTypes = `${response.data.eventTypes}, Other`.split(',')
          this.participants = response.data.participants
        })
      },
      validateSendBadgeInEmail () {
        if (this.$refs.badgeEmailForm.validate()) {
          this.sendBadgeMail()
        }
      },
      sendCertificateMail () {
        const badgeId = this.badgeId
        this.loadingSendCertificateMail = true
        this.$store.dispatch('exam/sendCertificateMail', badgeId).then(response => {
          this.$store.commit('flashSuccess', 'Mail sent successfully..')
          this.certificateMailSend = true
          this.loadingSendCertificateMail = false
        })
      },
      sendBadgeMail () {
        const badgeId = this.badgeId
        this.loadingSendBadgeMail = true
        this.$store.dispatch('exam/sendBadgeMail', {emails: this.badgeEmails, badgeId: badgeId}).then(response => {
          this.$store.commit('flashSuccess', 'Mail sent successfully..')
          this.badgeMailSend = true
          this.loadingSendBadgeMail = false
          this.badgeEmailFormValid = false
        })
      },
      formatTime (n) {
        return `${n / 60 ^ 0}:` + n % 60
      },
      getSelectedUSer (user) {
        this.badgeId = ''
        this.dialog = true
        this.selectedMember = user
        this.selectedUser = {}
        this.frontImg = ''
        this.$store.dispatch('complianceProgram/fetchUser', {courseId: 59, username: user.email}).then(response => {
          this.selectedUser = response.data
          if (this.selectedMember.progress.toLowerCase() === 'badged') {
            this.$store.dispatch('course/fetchBadgeData', {deckId: 59, userId: user.userId}).then(badge => {
              this.badgeId = badge.data.id
              this.$store.dispatch('exam/fetchBadgeFrontImage', { deckId: 59, userId: user.userId }).then(data => {
                let prefix = 'data:' + data.headers['content-type'] + ';base64,'
                let img = Buffer.from(data.data, 'binary').toString('base64')
                this.frontImg = prefix + img
              }).catch(err => {
                console.error('fetchBadgeFrontImageNew', err)
              })
            })
          }
        })
      }
    },
    watch: {
    }
  }
  </script>

<style lang="stylus" scoped>
.v-input__slot .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
  margin-bottom: 0!important;
}
</style>



// WEBPACK FOOTER //
// src/components/views/ComplianceCenter.vue